import { render, staticRenderFns } from "./BasicInfoView.vue?vue&type=template&id=088c8d54&"
import script from "./BasicInfoView.vue?vue&type=script&lang=ts&"
export * from "./BasicInfoView.vue?vue&type=script&lang=ts&"
import style0 from "./BasicInfoView.vue?vue&type=style&index=0&id=088c8d54&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports